import React, { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { apiFetch, safeJson, getToken, setToken, clearToken, ADMIN_KEY } from "@/lib/api";
import { AuthProvider } from "@/context/AuthContext";
import { Spinner, Logo } from "@/components/Spinner";
import AccessGate from "@/screens/AccessGate";
import MainContent from "@/components/MainContent";

function App() {
  const [accessToken, setAccessToken] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);
  const [initialProfileComplete, setInitialProfileComplete] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const stored = getToken();
        const storedAdmin = localStorage.getItem(ADMIN_KEY) === "true";
        if (stored) {
          const res = await apiFetch("/api/auth/check-access", {
            method: "POST",
            body: JSON.stringify({ token: stored }),
          });
          const data = await safeJson(res);
          if (data && data.authorized) {
            setAccessToken(stored);
            setIsAdmin(data.is_admin || storedAdmin);
          } else {
            clearToken();
          }
        }
      } catch {
        const stored = getToken();
        if (stored) {
          setAccessToken(stored);
          setIsAdmin(localStorage.getItem(ADMIN_KEY) === "true");
        }
      } finally {
        setChecking(false);
      }
    })();
  }, []);

  const handleAccessGranted = (token, admin, profileComplete) => {
    setToken(token, !!admin);
    if (profileComplete) setInitialProfileComplete(true);
    setAccessToken(token);
    setIsAdmin(!!admin);
  };

  const handleLogout = () => {
    clearToken();
    setAccessToken(null);
    setIsAdmin(false);
    setInitialProfileComplete(false);
  };

  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      {checking ? (
        <div className="min-h-screen flex flex-col items-center justify-center bg-black">
          <Logo size={22} />
          <Spinner size={22} color="#c8ff00" className="mt-6" />
        </div>
      ) : !accessToken ? (
        <AccessGate onAccessGranted={handleAccessGranted} />
      ) : (
        <AuthProvider token={accessToken} isAdmin={isAdmin} initialProfileComplete={initialProfileComplete}>
          <MainContent isAdmin={isAdmin} onLogout={handleLogout} />
        </AuthProvider>
      )}
    </div>
  );
}

export default App;
